module.exports = function() {
    var resourceId;
    var pageSize = 200;
    var dirStack = [];

    function getParentPath(path) {
        return (path.lastIndexOf("/") == 0)
            ? "/"
            : path.substring(0, path.lastIndexOf("/"));
    }

    this.init = function(vfsId) {
        resourceId = vfsId;
        dirStack = [];
    };

    this.createFolder = function(path) {
        return $.ajax({
            url : "/sslvpn_api/vfs/create",
            type : "POST",
            data : {
                vfsId : resourceId,
                target : path
            }
        });
    };

    this.delete = function(path) {
        var self = this;

        return $.ajax({
            url : "/sslvpn_api/vfs/delete",
            type : "POST",
            data : {
                vfsId : resourceId,
                target : path
            }
        }).then(function() {
            var parent = self.getDirectory(getParentPath(path));
            return parent.refresh()
                .then(function() {
                    return parent;
                });
        });
    };

    this.rename = function(oldPath, newPath) {
        var self = this;

        return $.ajax({
            url : "/sslvpn_api/vfs/move",
            type : "POST",
            data : {
                vfsId : resourceId,
                source : oldPath,
                destination : newPath
            }
        }).then(function() {
            var dir = self.getDirectory(oldPath);
            var parent;

            // If we are renaming a file, oldPath will include the file so dir will be undefined
            if (dir) {
                dir = self.setPath(newPath);
                parent = dir.getParent();
            } else {
                parent = self.getDirectory(getParentPath(oldPath));
            }

            var promises = [parent.refresh()];

            if (dir) {
                promises.push(dir.fetch());
            }
            return $.when.apply($, promises);
        });
    };

    this.setPath = function(path) {
        var currentPath = "";

        // Drop trailing slash and split into path steps
        var steps = path.replace(/\/+$/, "").split("/");

        // Update the directory stack as necessary
        for (var i = 0; i < steps.length; i++) {
            if (currentPath !== "/") {
                currentPath += "/";
            }
            currentPath += steps[i];

            if (dirStack.length > i) {
                if (dirStack[i].getName() == steps[i]) {
                    continue;
                } else {
                    // Throw away the rest of the directory stack
                    dirStack.splice(i, dirStack.length - i);
                }
            }
            dirStack.push(new Directory(steps[i], currentPath, dirStack.last()));
        }

        // Clean up any extra directory steps from previous path
        if (dirStack.length > steps.length) {
            dirStack.splice(steps.length, dirStack.length - steps.length);
        }

        return dirStack.last();
    };

    /*
     * Finds the currently loaded Directory object for the specified path
     * or null if the path has not been loaded
     */
    this.getDirectory = function(path) {
        var steps = path.replace(/\/+$/, "").split("/");

        if (steps.length <= dirStack.length) {
            var dir = dirStack[0];

            for (var i = 1; i < steps.length; i++) {
                if (steps[i] != dirStack[i].getName()) {
                    return undefined;
                }

                dir = dirStack[i];
            }
            return dir;
        }
        return undefined;
    };

    function Directory(name, path, parentDir) {
        var fileList = [];
        var pager = {
            current : 0,
            bottom : false
        };
        var currentFetch;

        function doFetch(from, to) {
            var _path = (path.substr(path.length - 1) === "/") ? path : path + "/"; // Path must end in a '/'

            var url = "/sslvpn_api/vfs/list?vfsId=" + resourceId +
                "&path=" + encodeURIComponent(_path) +
                "&from=" + from +
                "&to=" + to;

            currentFetch = $.ajax({
                url : url,
                cache : false
            });

            return currentFetch;
        }

        this.getParent = function() {
            return parentDir;
        };

        this.getName = function() {
            return name;
        };

        this.getPath = function() {
            return path;
        };

        this.getContents = function() {
            if (fileList.length != 0 || pager.bottom) {
                return $.Deferred().resolve(fileList).promise();
            }

            return this.fetch();
        };

        this.refresh = function() {
            if (currentFetch) {
                currentFetch.abort();
            }

            var to = (pager.current == 0) ? pageSize : pager.current;
            return doFetch(0, to)
                .done(function(response) {
                    fileList = response;
                }).always(function() {
                    currentFetch = undefined;
                });
        };

        this.getFile = function(filename) {
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].name == filename) {
                    return fileList[i];
                }
            }
            return undefined;
        };

        this.fetch = function() {
            if (currentFetch || pager.bottom) {
                return $.Deferred().resolve([]).promise();
            }

            var from = pager.current;
            var to = pager.current + pageSize - 1;

            return doFetch(from, to)
                .done(function(response) {
                    pager.current += pageSize;
                    pager.bottom = response.length < pageSize;
                    fileList = fileList.concat(response);
                }).always(function() {
                    currentFetch = undefined;
                });
        };
    }
};